// The import card in the platform agent's panel (D12): before a menu import or a copy runs, while it runs, and how it
// ended. Wording from the Amigo for menus design's copy sheet (Import card, Not live yet, Buttons, Importing, Failed,
// What to try, the 5 reasons, Went live, Import done).
export default {
  title: {
    import: 'Importér menuen fra {{platform}}',
    copy: 'Kopiér menuen fra {{restaurant}}',
    data: 'Opret menuen, som Amigo læste',
  },
  // A menu Amigo read from a file or the chat (QA36): a change card with each dish, before it is created.
  contents: {
    title: 'Opret {{categories}} og {{dishes}}',
    from: {
      file: 'Amigo har læst dette fra din fil',
      chat: 'Amigo har læst dette fra vores chat',
    },
    summary: 'Opretter {{categories}} og {{dishes}}. Tjek hver ret med dens pris på listen nedenfor.',
    price: 'Pris',
    tax_category: 'Momskategori',
    no_price: 'Ingen pris endnu',
    default_tax: 'Din standardsats',
    // Once approved: the import's run, in the words of creating a menu.
    creating: 'Opretter {{categories}} og {{dishes}}…',
    done: 'Menuen er oprettet: {{categories}}, {{dishes}} og {{option_groups}} er nu på {{restaurant}}s menu',
    done_plain: 'Menuen er oprettet',
  },
  waiting: 'Afventer godkendelse',
  labels: {
    from: 'Fra',
    to: 'Til',
    menu: 'Menu',
    brings_over: 'Overfører',
  },
  from: {
    // "Lieferando · lieferando.de/speisekarte/pizzeria-lupo-koeln"
    platform: '{{platform}} · {{link}}',
    // "Pizzeria Lupo · 12 categories, 140 dishes"
    restaurant: '{{restaurant}} · {{categories}}, {{dishes}}',
    // "The menu Amigo read · 2 categories, 4 dishes" (B19)
    data: 'Menuen Amigo læste · {{categories}}, {{dishes}}',
  },
  to: {
    only_location: '{{name}}, den eneste lokation',
    brand_one: '{{name}}-brandmenu, kun én lokation',
    brand_other: '{{name}}-brandmenu, alle {{count}} lokationer',
  },
  menu: {
    empty: 'Tom, så denne bliver menuen',
    adds: 'Føjes til den nuværende menu ({{size}}). Retter med samme navn opdateres; intet fjernes.',
    // The menu's name and size: "Speisekarte: 12 categories, 140 dishes".
    size_named: '{{name}}: {{categories}}, {{dishes}}',
    size: '{{categories}}, {{dishes}}',
  },
  counts: {
    categories_one: '{{count}} kategori',
    categories_other: '{{count}} kategorier',
    dishes_one: '{{count}} ret',
    dishes_other: '{{count}} retter',
    option_groups_one: '{{count}} tilvalgsgruppe',
    option_groups_other: '{{count}} tilvalgsgrupper',
  },
  // What an import brings over, as one list: "Categories, dishes, prices, option groups, photos, and allergens and
  // nutrition where Lieferando has them". Each item starts lowercase; the list's first letter is capitalised.
  brings_over: {
    everything: 'Alt, som det er',
    categories: 'kategorier',
    dishes: 'retter',
    descriptions: 'beskrivelser',
    prices: 'priser',
    option_groups: 'valggrupper',
    photos: 'fotos',
    where: {
      allergens_nutrition: 'allergener og næringsindhold, hvor {{platform}} har dem',
      allergens: 'allergener, hvor {{platform}} har dem',
      nutrition: 'næringsindhold, hvor {{platform}} har det',
    },
  },
  not_live: '{{restaurant}} er ikke live endnu: gæster kan se menuen på shoplinket, men kan ikke bestille.',
  buttons: {
    import: 'Importér',
    copy: 'Kopiér',
    cancel: 'Annullér',
  },
  hint: 'Eller svar nedenfor for at ændre noget.',
  action_failed: 'Det gik ikke igennem, så intet er ændret. Prøv igen om lidt.',
  // Shop's 409 codes when Import is pressed again while the first one runs (QA125).
  refused: {
    already_running: 'Dette import kører allerede. Amigo giver dig besked her, når det er færdigt.',
    already_applying: 'Det anvendes lige nu. Vent et øjeblik, til det er færdigt.',
  },
  importing: {
    title: {
      import: 'Importerer fra {{platform}}…',
      copy: 'Kopierer fra {{restaurant}}…',
    },
    started: 'Startet {{time}}',
    queued: 'Starter…',
    hint: 'Det kan tage et par minutter. Du kan lukke panelet eller fortsætte med at arbejde; jeg skriver resultatet her.',
  },
  done: {
    // What is on the menu now, while the card is the only result ({{categories}} … are `counts`): "The import from
    // Lieferando is done: 12 categories, 140 dishes and 38 option groups are on Pizzeria Lupo's menu".
    title: {
      import:
        'Importen fra {{platform}} er færdig: {{categories}}, {{dishes}} og {{option_groups}} er på {{restaurant}}s menu',
      copy: 'Kopieringen er færdig: {{categories}}, {{dishes}} og {{option_groups}} er på menuen',
    },
    // Without counts, or once Amigo's result under the card says them.
    title_plain: {
      import: 'Importen fra {{platform}} er færdig',
      copy: 'Kopieringen er færdig',
    },
    finished: 'Færdig {{time}}',
    // The page in the sidebar's words: "Open Menu → Manage menus".
    open: 'Åbn {{page}}',
  },
  failed: {
    title: {
      import: 'Kunne ikke importere: {{reason}}',
      copy: 'Kunne ikke kopiere: {{reason}}',
    },
    title_plain: {
      import: 'Kunne ikke importere',
      copy: 'Kunne ikke kopiere',
    },
    nothing: {
      import: 'Intet blev importeret.',
      copy: 'Intet blev kopieret.',
    },
    what_to_try: 'Det kan du prøve:',
    retry: 'Prøv igen',
    reasons: {
      listing_not_found: {
        title: 'opslag ikke fundet',
        text: '{{platform}} har ingen restaurant på dette link. Intet blev importeret.',
        try: 'Åbn linket i en browser for at se, om det viser restaurantens menu, og send det derefter igen.',
      },
      listing_not_supported: {
        title: 'opslag understøttes ikke',
        text: 'Dette er en kædeside på {{platform}}, ikke en enkelt restaurants menu, så jeg kan ikke importere den. Intet blev importeret.',
        try: 'Send linket til restaurantens egen menuside på {{platform}}.',
      },
      platform_failed: {
        title: '{{platform}} mislykkedes',
        text: '{{platform}} svarede ikke, så intet blev importeret.',
        try: 'Prøv igen om nogle minutter.',
      },
      // A copy from another restaurant that failed on our side: there is no platform to name.
      copy_failed: {
        title: 'kopieringen mislykkedes',
        text: 'Kopieringen blev ikke gennemført, så intet blev kopieret.',
        try: 'Prøv igen om nogle minutter.',
      },
      // {{listing}} and {{currency}} are currencies with their sign: "British pounds (£)", "euros (€)". {{page}} is the
      // sidebar's My info.
      currency_mismatch: {
        title: 'valutaen stemmer ikke overens',
        text: 'Opslaget er i {{listing}}, men {{restaurant}} bruger {{currency}}. Intet blev importeret.',
        try: 'Send et opslag i {{currency}}, eller tjek først restaurantens valuta under {{page}}.',
        text_other: 'Opslaget er i en anden valuta end {{restaurant}}s. Intet blev importeret.',
        try_other: 'Send et opslag i restaurantens valuta, eller tjek først dens valuta under {{page}}.',
      },
      link_paused: {
        title: 'link sat på pause',
        text: 'Dette link mislykkedes 3 gange i træk, så import fra det er sat på pause indtil {{time}}. Intet blev importeret.',
        text_no_until:
          'Dette link mislykkedes 3 gange i træk, så import fra det er sat på pause for nu. Intet blev importeret.',
        try: 'Send et link fra en anden platform, eller kopiér menuen fra en anden restaurant.',
      },
    },
  },
  stopped: {
    title: 'Stoppet: {{restaurant}} gik live',
    nothing: {
      import: 'Intet blev importeret',
      copy: 'Intet blev kopieret',
    },
  },
  // The card folded to one line.
  line: {
    cancelled: 'Annulleret',
    expired: 'Udløbet',
    replaced: 'Erstattet',
  },
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Godkendt.',
    cancelled: 'Annulleret.',
    retried: 'Prøvet igen.',
  },
};
